module.exports = __webpack_public_path__ + "static/media/bs_3.104d652d.jpg";